import * as React from "react";

function SvgRepeater(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 59.8 72"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>
          {
            ".Repeater_svg__a{fill:#fbbf93}.Repeater_svg__b{fill:#9d5025}.Repeater_svg__c{fill:#f58536}"
          }
        </style>
      </defs>
      <path
        className="Repeater_svg__a"
        d="M59.7 40.2L29.8 39 0 40.2l29.8 13.7 29.9-13.7z"
      />
      <path className="Repeater_svg__b" d="M0 36h35.9V3l-6-3L0 14.9V36z" />
      <path
        className="Repeater_svg__a"
        d="M59.8 50.8l-29.9-4.3L0 50.8 30 72l29.8-21.2z"
      />
      <path
        className="Repeater_svg__b"
        d="M29.9 36h15.8V13.5l-4.6-1.8-11.2 3.2V36z"
      />
      <path
        className="Repeater_svg__b"
        d="M41.1 36h12.2V21.4l-3.5-1-8.7 1.4V36z"
      />
      <path
        className="Repeater_svg__b"
        d="M49.8 36h9.9l.1-16.9-3-1.2-7 1.3V36z"
      />
      <path
        className="Repeater_svg__c"
        d="M35.9 3l-6-3v36h6V3zM45.7 13.5l-4.6-1.8V36h4.6V13.5zM53.3 21.4l-3.5-1V36h3.5V21.4zM56.8 17.9l3 1.2V36h-3V17.9zM59.7 46.5l-29.9 7.4V43.2l29.9-3v6.3zM59.8 50.8l-30 10.6V72l30-15v-6.2z"
      />
      <path
        className="Repeater_svg__b"
        d="M0 50.8l29.8 10.5V72L0 57.1v-6.3zM0 40.2l29.8 3v10.7L0 46.5v-6.3z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgRepeater);
